import { productImage, catAccent, initials } from "@/lib/images";
import { Package } from "lucide-react";

export default function ProductThumb({ product, className = "" }) {
  const img = productImage(product);
  if (img) {
    return <img src={img} alt={product?.name || ""} loading="lazy" className={`object-cover ${className}`} />;
  }
  const ini = initials(product?.name || "");
  return (
    <div className={`flex items-center justify-center bg-gradient-to-br ${catAccent(product?.category || product?.sku || "")} ${className}`}>
      {ini ? <span className="font-heading font-bold text-white/95">{ini}</span> : <Package className="h-5 w-5 text-white/90" />}
    </div>
  );
}
